(function () {
    'use strict';

    angular
        .module('app')
        .controller('MemberPublicController', MemberPublicController);

    MemberPublicController.$inject = ['$http', '$rootScope', '$state', '$cookies', '$scope', '$filter', 'authenticator', '$stateParams', 'emojiReplacer', 'cache'];

    function MemberPublicController($http, $rootScope, $state, $cookies, $scope, $filter, authenticator, $stateParams, emojiReplacer, cache) {
        $rootScope.header_inverted = false;
        $rootScope.on_dashboard = false;
        $rootScope.separate_page = false;
        $rootScope.dark_text_header = true;
        $rootScope.separate_page = true;
        var vm = this;

        vm.$onInit = function () {
            window.document.title = $stateParams.language == 'da' ? "Din profil - Be My Concert" : "Your profile - Be My Concert";
            Promise.all([getUser(), getUserAffilliates()]).then(function () {
            });
        };

        function getUserAffilliates() {
            return $http.get('api/users/user_affiliates/')
                .then(function (response) {
                    vm.user_bands = response.data.affiliates.band;
                    vm.user_hosts = response.data.affiliates.space;
                });
        }

        $scope.$on('$destroy', function () {
            $rootScope.dark_text_header = false;
            $rootScope.separate_page = false;
        })

        function getUser() {
            return $http.get('api/users/'+$stateParams.user_slug+'/')
                .then(function (response) {
                    vm.user = response.data;
                });
        }
    }
})();
